import React, { useEffect, useState } from 'react';
import { ProfileWidget } from './ProfileWidget';
import { TokenizationWidget } from './TokenizationWidget';
import { RoyaltyKpiWidget } from './RoyaltyKpiWidget';
import { RecentWorksWidget } from './RecentWorksWidget';
import { SocialFeedWidget } from './SocialFeedWidget';
import { WelcomeModal } from './WelcomeModal';
export function Dashboard() {
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  // Check if user is coming from onboarding
  useEffect(() => {
    // In a real app, this would check a query parameter or session storage
    // For demo purposes, we'll just show the modal
    const isNewUser = sessionStorage.getItem('isNewUser');
    if (isNewUser === 'true' || window.location.search.includes('new=true')) {
      setShowWelcomeModal(true);
      sessionStorage.removeItem('isNewUser');
    }
  }, []);
  return <div className="space-y-4 md:space-y-6 pb-6 max-w-[1600px] mx-auto bg-[#EFF2F1]/30" data-id="element-61">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-62">
        <ProfileWidget data-id="element-63" />
        <TokenizationWidget data-id="element-64" />
        <RoyaltyKpiWidget data-id="element-65" />
      </div>
      <RecentWorksWidget data-id="element-66" />
      <SocialFeedWidget data-id="element-67" />
      {/* Welcome Modal */}
      <WelcomeModal isOpen={showWelcomeModal} onClose={() => setShowWelcomeModal(false)} data-id="element-68" />
    </div>;
}